const isBrowser = (browserName: string): boolean => {
  return navigator.userAgent.indexOf(browserName) !== -1;
};

export const isFirefox = (): boolean => {
  return isBrowser('Firefox');
};

export const isEdge = (): boolean => {
  return isBrowser('Edg');
};

export const isChrome = (): boolean => {
  return isBrowser('Chrome');
};

export const isOpera = (): boolean => {
  return isBrowser('Opera') || isBrowser('OPR');
};

export const isSafari = (): boolean => {
  return isBrowser('Safari');
};
